import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { api } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null); // null = loading, false = anon, obj = user
    const [checked, setChecked] = useState(false);

    useEffect(() => {
        // Auth state is derived from the httpOnly cookie only.
        // If /auth/me returns 200, user is authenticated. Otherwise anonymous.
        api.get("/auth/me")
            .then((r) => setUser(r.data))
            .catch(() => setUser(false))
            .finally(() => setChecked(true));
    }, []);

    const login = useCallback(async (email, password) => {
        const { data } = await api.post("/auth/login", { email, password });
        setUser(data);
        return data;
    }, []);

    const logout = useCallback(async () => {
        try {
            await api.post("/auth/logout");
        } catch (err) {
            // Non-fatal: log for visibility (dev only) but still clear local state
            if (process.env.NODE_ENV !== "production") {
                console.warn("Logout request failed, clearing local session anyway:", err?.message);
            }
        }
        setUser(false);
    }, []);

    const value = useMemo(
        () => ({ user, checked, login, logout }),
        [user, checked, login, logout],
    );

    return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
